<div class="container conteudo mt-4" [formGroup]="form">
  <div class="mt-3 cabecalho">
    <p class="cabecalho__contexto">Instituto Previdenciário</p>
    <h1 class="titulo">Solicitação de Autopatrocínio</h1>
  </div>

  <vivest-card class="secao" variant="elevated" full-width>
    <div class="secao__conteudo">
      <div class="bloco-principal">
        <section class="secao__cabecalho" aria-labelledby="titulo-contribuicoes">
          <h4 id="titulo-contribuicoes">Contribuições mensais no plano</h4>
          <p class="texto-apoio">
            Como autopatrocinado, você passa a contribuir mensalmente na sua previdência. Para
            definir o valor do investimento, você escolhe um percentual do seu último salário, de
            acordo com as regras do plano. Escolha como deseja continuar a contribuição do plano:
          </p>
        </section>

        <!-- Salário -->
        <section class="grupo" aria-labelledby="titulo-salario">
          <h6 id="titulo-salario" class="grupo__titulo">Salário base para cálculo</h6>
          <div class="linha linha--base">
            <vivest-input
              formControlName="salario"
              vivestFormat="moeda"
              class="campo"
              label="Valor do Salário"
              name="salario"
              icon=""
              placeholder=""
              type="text"
              (focusout)="onSalarioBlur()"
            ></vivest-input>
            <p class="texto-apoio linha__descricao">
              Valor do salário utilizado para calcular a contribuição mensal.
            </p>
          </div>
        </section>

        <vivest-switch
          label-variant="multi-line"
          name="cancelar-contribuicoes"
          [checked]="cancelarContribuicoes()"
          (change)="onCancelarChange($event)"
        >
          Desejo cancelar as minhas contribuições (Contribuição passa a ser R$ 0,00)
        </vivest-switch>

        <div class="contribuicoes">
          <!-- Básica: habilitada pelo .ts quando o plano e o salário permitem. -->
          <section class="grupo grupo--contribuicao" aria-labelledby="titulo-basica">
            <h6 id="titulo-basica" class="grupo__titulo">Contribuição Básica</h6>
            <div class="grupo__campo">
              <vivest-input
                formControlName="basica"
                vivestFormat="decimal"
                class="campo"
                label="Percentual do salário a ser investido"
                name="contribuicao-basica"
                icon="custom"
                placeholder=""
                type="text"
                (focusout)="onBasicaBlur()"
              >
                <span slot="icon" class="sufixo" aria-hidden="true">%</span>
              </vivest-input>
              <div class="texto-apoio">
                @if (aguardandoSalario()) {
                  <p>Informe o valor do salário para ver os limites do seu plano.</p>
                } @else if (limitesBasica(); as limites) {
                  <p>
                    Mínimo de {{ percentual(limites.minimo) }} e máximo de
                    {{ percentual(limites.maximo) }}.
                  </p>
                }
                <p>Você contribui com a sua parte e a parte que seria da empresa.</p>
              </div>
            </div>
          </section>

          <!-- Voluntária: só habilitada com a Básica no máximo permitido. -->
          <section class="grupo grupo--contribuicao" aria-labelledby="titulo-voluntaria">
            <h6 id="titulo-voluntaria" class="grupo__titulo">Contribuição Voluntária (Opcional)</h6>
            <div class="grupo__campo">
              <vivest-input
                formControlName="voluntaria"
                vivestFormat="decimal"
                class="campo"
                label="Percentual adicional de investimento"
                name="contribuicao-voluntaria"
                icon="custom"
                placeholder=""
                type="text"
                (focusout)="onVoluntariaBlur()"
              >
                <span slot="icon" class="sufixo" aria-hidden="true">%</span>
              </vivest-input>
              <div class="texto-apoio">
                <p>Somente válido se estiver no máximo da Básica.</p>
                <p>Caso não esteja, consideramos como 0%</p>
              </div>
            </div>
          </section>
        </div>
      </div>

      <!-- Total (só leitura: calculado a partir do salário e dos percentuais) -->
      <section class="grupo" aria-labelledby="titulo-total">
        <h6 id="titulo-total" class="grupo__titulo">Valor total da contribuição mensal</h6>
        <div class="linha linha--centro">
          <vivest-input
            class="campo"
            label="Contribuição Mensal (R$)"
            name="contribuicao-mensal"
            icon=""
            placeholder=""
            type="text"
            disabled
            [value]="moeda(valorTotal())"
          ></vivest-input>
          <div class="texto-apoio linha__descricao" aria-live="polite">
            <p>Salário base: {{ moeda(salario()) }}</p>
            <p>
              Básica (participante + patrocinador): {{ moeda(valorBasicaParticipante()) }} × 2 =
              {{ moeda(valorBasicaTotal()) }} + Voluntária: {{ moeda(valorVoluntaria()) }} =
              {{ moeda(valorTotal()) }}
            </p>
          </div>
        </div>
      </section>
    </div>
  </vivest-card>

  <!-- Suspensão temporária -->
  <vivest-card class="secao" variant="elevated" full-width>
    <section class="suspensao" aria-labelledby="titulo-suspensao">
      <div class="suspensao__texto">
        <h5 id="titulo-suspensao">Suspensão temporária de Contribuições</h5>
        <p class="texto-apoio">
          Você pode optar por suspender os próximos meses de contribuição em até 12 meses
        </p>
        <vivest-switch
          label-variant="multi-line"
          name="suspender-contribuicoes"
          [checked]="suspenderContribuicoes()"
          [disabled]="cancelarContribuicoes()"
          (change)="onSuspenderChange($event)"
        >
          Desejo suspender minhas próximas contribuições
        </vivest-switch>
      </div>
      <!-- Habilitado pelo .ts quando a suspensão está ativa. -->
      <vivest-input
        formControlName="meses"
        vivestFormat="digits"
        [vivestMaxLength]="2"
        class="campo suspensao__meses"
        label="Tempo de suspensão"
        name="meses-suspensao"
        icon=""
        placeholder="Máximo: 12 meses"
        type="text"
        (focusout)="onMesesBlur()"
      ></vivest-input>
    </section>
  </vivest-card>
</div>

<div class="d-flex justify-content-center align-items-center buttons top-64">
  <vivest-button variant="outline" size="md" (click)="onReturn()">
    Voltar
  </vivest-button>
  <vivest-button variant="primary" size="md" [disabled]="!podeContinuar()" (click)="onSubmit()">
    <vivest-icon slot="icon-right" name="arrow-right" source="feather"></vivest-icon>
    Continuar para assinatura
  </vivest-button>
</div>
